import createURL from './formatters/createURL';
import { ROUTES } from 'dictionary/routes';

export const router = {
  getRouteWithParams: (route, queryParams = {}) => {
    return createURL(route, { queryParams });
  },
  getOrderDetailsRoute: (orderId) => {
    return createURL(ROUTES.ORDER_DETAILS, {
      params: { id: orderId },
    });
  },
  getCreateRequestInitRoute: (orderId, requestId = '') => {
    return createURL(ROUTES.REQUEST.CREATE.INIT_CACHED, {
      params: { orderId, orderServiceId: requestId },
    });
  },
  getCreateRequestDetailsRoute: (requestId) => {
    return createURL(ROUTES.REQUEST.CREATE.DETAILS, {
      params: { serviceId: requestId },
    });
  },
  getCreateRequestConfirmationRoute: (requestId) => {
    return createURL(ROUTES.REQUEST.CREATE.CONFIRMATION, {
      params: { serviceId: requestId },
    });
  },
  getRequestDetailsRoute: (_orderId, requestId) => {
    return createURL(ROUTES.ACCOUNT.RETURNS_DETAILS, {
      params: { returnId: requestId },
    });
  },
};
